import { defineStore } from 'pinia';

const STORAGE_KEY = 'presentei_withdrawal_v1';
const TRANSFER_BLOCK_MINUTES = 60;

function defaultState() {
  return {
    lastTransferStartedAt: null,
    transferBlockedUntil: null,
  };
}

function loadFromStorage() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return defaultState();
    return { ...defaultState(), ...JSON.parse(raw) };
  } catch {
    return defaultState();
  }
}

export const useWithdrawalStore = defineStore('withdrawal', {
  state: () => loadFromStorage(),

  getters: {
    isTransferBlocked: (state) => {
      if (state.transferBlockedUntil) {
        return new Date(state.transferBlockedUntil) > new Date();
      }

      if (state.lastTransferStartedAt) {
        const expiresAt = new Date(state.lastTransferStartedAt);
        expiresAt.setMinutes(expiresAt.getMinutes() + TRANSFER_BLOCK_MINUTES);
        return expiresAt > new Date();
      }

      return false;
    },

    minutesUntilUnblocked: (state) => {
      let expiresAt = null;

      if (state.transferBlockedUntil) {
        expiresAt = new Date(state.transferBlockedUntil);
      } else if (state.lastTransferStartedAt) {
        expiresAt = new Date(state.lastTransferStartedAt);
        expiresAt.setMinutes(expiresAt.getMinutes() + TRANSFER_BLOCK_MINUTES);
      }

      if (!expiresAt) return 0;
      const diff = Math.ceil((expiresAt - new Date()) / 60000);
      return diff > 0 ? diff : 0;
    },
  },

  actions: {
    persist() {
      try {
        localStorage.setItem(
          STORAGE_KEY,
          JSON.stringify({
            lastTransferStartedAt: this.lastTransferStartedAt,
            transferBlockedUntil: this.transferBlockedUntil,
          }),
        );
      } catch {
        // silencioso
      }
    },

    setFromRetryStatus(payload = {}) {
      const nowIso = new Date().toISOString();
      const blockedUntil = payload?.transfer_blocked_until || null;
      const hasPendingTransfer = Boolean(payload?.has_pending_transfer);

      if (blockedUntil) {
        this.transferBlockedUntil = blockedUntil;
        this.lastTransferStartedAt = this.lastTransferStartedAt || nowIso;
      } else if (hasPendingTransfer) {
        this.lastTransferStartedAt = this.lastTransferStartedAt || nowIso;
      } else {
        this.lastTransferStartedAt = null;
        this.transferBlockedUntil = null;
      }

      this.persist();
    },

    markTransferStarted(blockedUntil = null) {
      this.lastTransferStartedAt = new Date().toISOString();
      this.transferBlockedUntil = blockedUntil || null;
      this.persist();
    },

    clearTransferBlock() {
      this.lastTransferStartedAt = null;
      this.transferBlockedUntil = null;
      this.persist();
    },
  },
});
